export default "__VITE_ASSET__DhBZ2wVG__"